/**
 * Which modifier key this keyboard calls "the command key".
 *
 * Extracted from `useSaveShortcut`'s `saveShortcutLabel` when a second surface
 * needed the same answer: the top-bar search shows the ⌘K chord that opens the
 * palette, and a second copy of this sniff would eventually disagree with the
 * first about what an iPad is.
 *
 * Modifier-key names are NOT translated. They are platform symbols, identical in
 * every locale — the same reasoning that keeps the language picker on native
 * names.
 */

/** Is this an Apple keyboard, where the command key is ⌘ rather than Ctrl? */
export function isApplePlatform(): boolean {
  if (typeof navigator === 'undefined') return false;
  // `userAgentData.platform` is the modern signal; `platform` is the fallback
  // still shipped by every browser (deprecated, never removed).
  const platform =
    (navigator as { userAgentData?: { platform?: string } }).userAgentData?.platform ??
    // eslint-disable-next-line @typescript-eslint/no-deprecated -- the only cross-browser fallback
    navigator.platform;
  return /mac|iphone|ipad|ipod/i.test(platform);
}

/** The chord for a command-key shortcut, as this platform writes it. */
export function commandChordLabel(key: string): string {
  return isApplePlatform() ? `⌘${key.toUpperCase()}` : `Ctrl+${key.toUpperCase()}`;
}
